<h3 mat-dialog-title *ngIf="data.title" id="{{data.id}}Title">{{ data.title }}</h3>
<mat-dialog-content #alertMessage>
  <div  id="{{data.id}}Content">
    <p aria-hidden="true" > {{ content.message }}</p>
    <span  [attr.aria-label]="content.convertedTimeMessage"></span>
</div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button
  mat-raised-button
  class="nsc-button"
  color="primary"
  type="button"
  (click)="resetCountdown()">OK</button>
</mat-dialog-actions>
